/* Вторая строка допработы в зарплате — «оплачено 4,5 ч: окно 6 ч минус игра 17:00 (1,5 ч)»
   (15.10.2026, владелец: строку не трогаем, пояснение под ней мелко и серо). Текст — ewPayText.ts. */
import { ewPayNote, type EwPayInfo } from "./ewPayText";
import css from "./ewPayNote.module.css";

/** Строкой под содержимым (в колонке строки или отдельным блоком). */
export function EwPayNote({ e }: { e: EwPayInfo }) {
  const text = ewPayNote(e);
  return text ? <span className={css.note}>{text}</span> : null;
}

/** Отдельной строкой таблицы ведомости — под строкой допработы, от колонки «время». */
export function EwPayNoteRow({ e, span }: { e: EwPayInfo; span: number }) {
  const text = ewPayNote(e);
  return text ? <tr className={css.noteRow}><td /><td colSpan={span} className={css.noteCell}>{text}</td></tr> : null;
}
